import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';
// Import services.
import {
	StylesService,
} from '@app/services';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formPerils_formContainer: {

		},
		formPerils_perilsLabelHeader: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				display: 'flex',
				padding: theme.spacing(0, 0, 3, 0),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				display: 'none',
			},
		},
		formPerils_perilsLabel: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			height: '100%',
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h5.fontSize,
		},
		formPerils_warningButtonContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				marginLeft: theme.spacing(1.5),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {

			},
		},
		formPerils_warningButton: {
			padding: theme.spacing(0),
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {

			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {

			},
		},
		formPerils_warningButtonIcon: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				color: theme.palette.warning.main,
				filter: `drop-shadow(0px 0px 8px ${StylesService.getInstance().hexToRgbCSS(theme.palette.warning.main, .8)})`,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				color: theme.palette.primary.contrastText,
				filter: `drop-shadow(0px 0px 7px ${StylesService.getInstance().hexToRgbCSS('#FFFFFF', .8)})`,
			},
		},
		formPerils_triaLabel: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h5.fontSize,
			padding: theme.spacing(0, 0, 3, 0),
		},
		formPerils_wholeRow: {
			padding: theme.spacing(3, 0),
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
		},
		formPerils_wholeRowColumn: {
			width: '100%',
			display: 'flex',
			flexDirection: 'column'
		},
	});
});

export default useStyles;
